/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

import Colors from '../../constants/Colors';
import { Container } from '../core';
import SiteFooter from './SiteFooter';
import SiteHeader from './SiteHeader';
import ZIndex from '../../constants/ZIndex';
import MediaQueries from '../../constants/MediaQueries';

class Page extends Component<{
  headerTheme: 'light' | 'dark' | 'opaque-dark',
  footerTheme: 'light' | 'dark' | 'dark-blue',
  showFooter?: boolean,
  children?: any,
  header?: any,
}> {
  static defaultProps = {
    headerTheme: 'dark',
    footerTheme: 'light',
    showFooter: true,
  };

  render() {
    let { children, headerTheme, footerTheme, showFooter, header } = this.props;

    return (
      <div className={Styles.Container}>
        <Container
          size="large"
          className={names(
            Styles.HeaderContainer,
            headerTheme === 'opaque-dark' && Styles.HeaderContainerOpaqueDark
          )}>
          {header || <SiteHeader theme={headerTheme === 'opaque-dark' ? 'dark' : headerTheme} />}
        </Container>
        <article className={Styles.Page}>
          <div className={Styles.PageContent}>{children}</div>
          {showFooter && (
            <div className={names(Styles.PageFooterWash, ThemeStyles[footerTheme].PageFooterWash)}>
              <Container padded={true} size="large">
                <SiteFooter theme={footerTheme} />
              </Container>
            </div>
          )}
        </article>
      </div>
    );
  }
}

const ThemeStyles = {
  light: {
    PageFooterWash: css`
      background-color: ${Colors.GrayLight};
    `,
  },
  dark: {
    PageFooterWash: css`
      background-color: ${Colors.IndigoDarkest};
    `,
  },
  'dark-blue': {
    PageFooterWash: css`
      background-color: #1c1f34;
    `,
  },
};

const Styles = {
  Container: css`
    width: 100%;
    position: relative;
    background: red;
  `,
  HeaderContainer: css`
    position: relative;
    z-index: ${ZIndex.Highest};
  `,
  HeaderContainerOpaqueDark: css`
    background: ${Colors.IndigoDark};
    ${MediaQueries.Medium} {
      background: transparent;
    }
  `,
  Page: css`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    min-height: 100%;
    background-color: ${Colors.White};
  `,
  PageContent: css`
    flex: 1;
  `,
  PageFooterWash: css`
    overflow-x: hidden;
  `,
};

export default Page;



// WEBPACK FOOTER //
// ./src/ui/components/chrome/Page.js